import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { displayFormattedDate, formatCurrency, isEmpty } from '../../../generalFunctions';
import { FIRM_NAME } from '../../../constants';

const styles = StyleSheet.create({
    rowView: {
        flexDirection: 'row', border: '1px solid #000', padding: 10, textAlign: "left", alignSelf: "flex-start", marginRight: 25
    }
});

const PeriodwiseBillwiseReceiptPending = (props) => {
    const { startDate, endDate } = props.dates;
    let totalBalanceAmount = 0; let totalReceivedAmount = 0; let totalBillAmount = 0;
    props.data?.forEach((element, index) => {
        element.invoiceDate = displayFormattedDate(element.invoiceDate);
        element.receivedAmount = element.finalBillAmount - element.balanceAmount;

        totalBalanceAmount = totalBalanceAmount + element.balanceAmount;
        totalReceivedAmount = totalReceivedAmount + element.receivedAmount;
        totalBillAmount = totalBillAmount + element.finalBillAmount;

        element.finalBillAmount = Number(element.finalBillAmount).toFixed(2);
        element.balanceAmount = Number(element.balanceAmount).toFixed(2);
        element.receivedAmount = Number(element.receivedAmount).toFixed(2);
    });

    props.data.push({
        balanceAmount: Number(totalBalanceAmount).toFixed(2),
        finalBillAmount: Number(totalBillAmount).toFixed(2),
        receivedAmount: Number(totalReceivedAmount).toFixed(2)
    });

    const tableData = {
        columnName: ["Inv No", "Inv Dt", "Party Name", "Bill Amt", "Recd Amt", "Bal Amt", "Rec. Ent No"],
        column: ["id", "invoiceDate", "accountName", "finalBillAmount", "receivedAmount", "balanceAmount", "receiptId"],
        width: [8, 13, 37, 10, 10, 10, 10],
        align: ["left", "left", "left", "right", "right", "right", "right"],
        data: props.data
    }

    return (
        <Page style={{ padding: 15 }} id={props.data.id} orientation="landscape">
            <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 7, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 16,
                    flexDirection: "column",
                    flexGrow: 1
                }}>{FIRM_NAME}</Text>
            </View>
            <View style={{ flexDirection: 'row', textAlign: "center", marginBottom: 15 }}>
                <Text style={{ fontSize: 9, fontWeight: "bold", marginRight: 5 }}>{`Receivable Invoice Register From: ${displayFormattedDate(startDate)} To ${displayFormattedDate(endDate)}`}</Text>
            </View>
            <View style={{ innerHeight: "80%" }}>
                <View style={styles.rowView}>
                    {tableData["columnName"].map((c, index) => <Text key={index} style={{
                        width: `${tableData["width"][index]}%`, textAlign: `${tableData["align"][index]}`, fontSize: 9, marginRight: 1
                    }}>{c.toUpperCase()}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={{ flexDirection: 'row', border: '1px solid #000', padding: 9, alignSelf: "flex-start", marginRight: 25 }}>
                        {tableData["column"].map((c, index) =>
                            <Text key={index} style={{ width: `${tableData["width"][index]}%}%`, textAlign: `${tableData["align"][index]}`, fontSize: 9 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </View>
        </Page>
    );
}

export default PeriodwiseBillwiseReceiptPending;